import { fg } from '@atlaskit/platform-feature-flags';

import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

import { ContentStatus } from '../constants/ContentStatus';

import { preloadDataClassificationEnabled } from './preloadDataClassificationEnabled';
import { preloadContentDataClassification } from './preloadContentDataClassification';
import { preloadDefaultAndSpaceClassificationLevels } from './preloadDefaultAndSpaceClassificationLevels';

export async function preloadClassificationContextForViewContent(
	contentId: string,
	spaceKey?: string,
): Promise<any> {
	const queries: Promise<any>[] = [];

	const result = await preloadDataClassificationEnabled();
	const isDataClassificationEnabled = result?.data?.isDataClassificationEnabled;

	if (isDataClassificationEnabled) {
		queries.push(preloadContentDataClassification(contentId, ContentStatus.CURRENT));

		if (spaceKey && !fg('dlp_cc-minimize-classifications-queries')) {
			queries.push(preloadDefaultAndSpaceClassificationLevels(spaceKey));
		}
	}

	return waitForAllReturnWhenError(queries);
}
